import type { Testimonial } from "@app-types/index";

export const testimonials: Testimonial[] = [
  {
    name: "Lucía M.",
    role: "Cliente desde 2019",
    quote:
      "Atención personalizada de verdad. Cuando tuve un siniestro me acompañaron en cada paso, sin perder tiempo en call centers.",
  },
  {
    name: "Familia Pérez",
    role: "Hogar + Automotor",
    quote:
      "Contratamos hogar y dos autos. La diferencia con cotizadores online es real: te explican qué cubre cada cosa y por qué.",
  },
  {
    name: "Comercial Norte S.A.",
    role: "Cliente empresarial",
    quote:
      "Renovamos toda la flota y el integral del depósito con ellos. Cotizaciones claras y respuesta inmediata.",
  },
];
